
export default class collapser {
    constructor() {

        this.containers = document.querySelectorAll('.cp-collapse');
        if (this.containers.length === 0) return;

        this.GroupsBtnsToggleCollapse = [];

        Array.from(this.containers).forEach((container) => {
            this.GroupsBtnsToggleCollapse.push(container.querySelectorAll('.collapse-container__item__collapser'));
        });

        Array.from(this.GroupsBtnsToggleCollapse).forEach((GroupBtnsToggleCollapse) => {
            Array.from(GroupBtnsToggleCollapse).forEach((btnToggleCollapse) => {
                btnToggleCollapse.addEventListener('click', this.toggleCollapse.bind(this));
            });
        });
    }

    toggleCollapse(event){
        let collapser = event.currentTarget;
        let container = event.currentTarget.closest('.collapse-container__item').querySelector('.collapse-container__content');
        event.preventDefault();

        if (!container.classList.contains('active')) {

            collapser.classList.add('active');
            container.classList.add('active');
            container.style.height = 'auto';

            var height = container.clientHeight + 'px';

            container.style.height = '0px';

            setTimeout(function () {
                container.style.height = height;
            }, 0);

        } else {

            container.style.height = '0px';

            container.addEventListener('transitionend', function () {
                container.classList.remove('active');
                collapser.classList.remove('active');
            }, {
                once: true
            });

        }

    };


}
